import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TfiCheck } from 'react-icons/tfi';
import TableCollapse from '../tableCollapse';
import osImage from '../../assets/img/os.png';

function OsColumns() {
    const { t } = useTranslation();
    const [openSections, setOpenSections] = useState({});

    const toggleCollapse = (id) => {
        setOpenSections((prevSections) => ({
            ...prevSections,
            [id]: !prevSections[id]
        }));
    };
    const green = '#00af60';

    return (
        <Row>
            <Col md={6}>
                <div className="os-left-column">
                    <p>
                        <strong>
                            <span className="smartcolor">Linux</span>
                        </strong>
                        : Ubuntu, Debian, AlmaLinux, Rocky, Oracle, Rocky.
                    </p>
                    <p>
                        <strong>
                            <span className="powercolor">Windows</span>{' '}
                        </strong>
                        : Windows Server 2019, 2022 ({t('vps-page.os-with-license')}).
                    </p>
                </div>
            </Col>
            <Col md={6}>
                <img className="os-image" src={osImage} alt="OS" />
            </Col>
            <div className="table-wrapper">
                <TableCollapse
                    isOpen={!!openSections.section1}
                    toggle={toggleCollapse}
                    id="section1"
                    title={t('vps-page.os-column-title')}
                >
                    <table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>{t('vps-page.os-table.title-1')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('vps-page.os-table.title-2')}</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Debian 11</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Debian 12</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Ubuntu 22 (LTS)</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>AlmaLinux 10</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>AlmaLinux 9</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>CentOS 10</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Oracle 10</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Rocky 10</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                            <tr>
                                <th>Rocky 9</th>
                                <td>
                                    {' '}
                                    <TfiCheck color={green} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </TableCollapse>
            </div>
        </Row>
    );
}

export default OsColumns;
